import Router from "next/router";

export const visitStoreWebsite = (url: string, openNewTab = true): void => {
    if (openNewTab) {
        window.open(url);
    } else {
        Router.push(url);
    }
};
